import { Play, Radio, Home, Search, Film, Settings } from "lucide-react";

const TILES = ["Sunday Service", "Wednesday Bible Study", "Youth Night", "Easter Celebration"];
const SHADES = [0.55, 0.4, 0.3, 0.45];

function Logo({ pkg, className }) {
  return pkg.logo_url
    ? <img src={pkg.logo_url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${pkg.logo_url}` : pkg.logo_url} alt="" className={"object-contain " + className} />
    : <span className={"font-bold text-white truncate " + className}>{pkg.church_name || "Your Church"}</span>;
}

const Tile = ({ title, color, accent, focused, live, w }) => (
  <div className="shrink-0 rounded-md overflow-hidden transition-transform" style={{ width: w, background: color, outline: focused ? `2px solid ${accent}` : "none", outlineOffset: 2, transform: focused ? "scale(1.06)" : "none" }}>
    <div className="aspect-video flex items-center justify-center" style={{ background: live ? color : `linear-gradient(135deg, ${accent}33, #00000066)` }}>
      {live ? <span className="text-[8px] font-black tracking-widest" style={{ color: accent }}>WATCH LIVE</span> : <Play className="h-3 w-3 text-white/60" />}
    </div>
    <p className="px-1.5 py-1 text-[7px] font-semibold text-white truncate">{title}</p>
  </div>
);

export function RokuPreview({ pkg }) {
  const { primary_color: p, secondary_color: s, accent_color: a } = pkg;
  return (
    <div data-testid="preview-roku" className="aspect-video w-full overflow-hidden" style={{ background: p }}>
      <div className="h-[14%] flex items-center gap-3 px-[5%]" style={{ background: s }}>
        <Logo pkg={pkg} className="h-[60%] max-w-[22%] text-[10px]" />
        {pkg.logo_url && <span className="text-[9px] font-bold text-white truncate">{pkg.church_name}</span>}
      </div>
      <p className="px-[5%] pt-[2.5%] text-[7px] text-white/70 truncate">{pkg.church_name || "Your Church"} live stream</p>
      <div className="px-[5%] pt-[2%] space-y-[2.5%]">
        {[["Live", [["Watch Live", true]]], ["Recent Services", TILES.map((t) => [t, false])]].map(([label, items], r) => (
          <div key={label}>
            <p className="text-[8px] font-bold mb-1" style={{ color: a }}>{label}</p>
            <div className="flex gap-2">
              {items.map(([t, live], i) => <Tile key={t} title={t} live={live} color={s} accent={a} focused={r === 0 && i === 0} w="26%" />)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function LeanbackPreview({ pkg }) {
  const { primary_color: p, secondary_color: s, accent_color: a } = pkg;
  return (
    <div data-testid="preview-androidtv" className="aspect-video w-full overflow-hidden flex" style={{ background: p }}>
      <div className="w-[22%] h-full py-[4%] px-[2.5%] space-y-2" style={{ background: s }}>
        {[[Home, "Live"], [Film, "Recent Services"], [Search, "Search"], [Settings, "Settings"]].map(([Icon, l], i) => (
          <div key={l} className="flex items-center gap-1.5 rounded px-1.5 py-1 text-[7px] font-semibold" style={{ background: i === 0 ? a : "transparent", color: i === 0 ? "#000" : "#fffc" }}>
            <Icon className="h-2.5 w-2.5" /> {l}
          </div>
        ))}
      </div>
      <div className="flex-1 min-w-0 py-[4%] px-[3%]">
        <div className="flex items-center justify-end h-[10%] mb-[3%]"><Logo pkg={pkg} className="h-full max-w-[40%] text-[10px]" /></div>
        {[["Live", [["Watch Live", true]]], ["Recent Services", TILES.map((t) => [t, false])]].map(([label, items], r) => (
          <div key={label} className="mb-[4%]">
            <p className="text-[8px] font-semibold text-white/80 mb-1">{label}</p>
            <div className="flex gap-1.5">
              {items.map(([t, live], i) => (
                <div key={t} className="shrink-0 w-[30%] rounded-sm overflow-hidden" style={{ opacity: r === 0 || i < 3 ? 1 : SHADES[i] }}>
                  <div className="aspect-video flex items-center justify-center" style={{ background: live ? s : `linear-gradient(135deg, ${a}33, #00000066)` }}>
                    {live ? <Radio className="h-3 w-3" style={{ color: a }} /> : <Play className="h-3 w-3 text-white/60" />}
                  </div>
                  <div className="px-1 py-0.5" style={{ background: r === 0 && i === 0 ? a : s }}>
                    <p className="text-[7px] font-semibold truncate" style={{ color: r === 0 && i === 0 ? "#000" : "#fff" }}>{t}</p>
                    <p className="text-[6px] truncate" style={{ color: r === 0 && i === 0 ? "#000a" : "#fff9" }}>{live ? "LIVE" : "Recorded service"}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function TvFrame({ label, children }) {
  return (
    <div className="space-y-2">
      <p className="text-xs font-semibold text-gray-400 tracking-wide uppercase">{label}</p>
      <div className="rounded-xl bg-black p-2 shadow-2xl shadow-black/50 ring-1 ring-gray-800">
        <div className="rounded-md overflow-hidden">{children}</div>
      </div>
      <div className="mx-auto h-2 w-24 rounded-b-lg bg-gray-800" />
    </div>
  );
}
